import { Instagram, Linkedin, Facebook } from "lucide-react";

export default function Footer({ profile }) {
  const social = profile?.social || {};
  return (
    <footer className="bg-[#0A1128] text-[#FAF9F6]">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-20">
        <div className="grid md:grid-cols-3 gap-12">
          <div className="md:col-span-1">
            {profile?.logo ? (
              <img src={profile.logo} alt={profile?.name} className="h-16 w-auto object-contain bg-[#FAF9F6] p-2" />
            ) : (
              <h3 className="font-serif text-3xl mb-4">{profile?.name || "Mabel McMillan"}</h3>
            )}
            <p className="text-[#FAF9F6]/60 text-sm leading-relaxed max-w-xs mt-4">{profile?.tagline}</p>
            <div className="mt-8">
              <p className="text-[10px] uppercase tracking-[0.24em] text-[#FAF9F6]/40 mb-3">Affiliated Brokerage</p>
              <img src="/remax-cayman.png" alt="RE/MAX Cayman Islands" data-testid="remax-logo" className="h-10 w-auto object-contain bg-[#FAF9F6] px-4 py-2 rounded-sm" />
            </div>
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.24em] text-[var(--gold)] mb-5">Contact</p>
            <p className="text-[#FAF9F6]/80 text-sm mb-2">{profile?.email}</p>
            <p className="text-[#FAF9F6]/80 text-sm">{profile?.phone}</p>
            {profile?.address && <p className="text-[#FAF9F6]/60 text-sm mt-3 leading-relaxed max-w-xs">{profile.address}</p>}
            <div className="flex gap-4 mt-6">
              {social.instagram && <a href={social.instagram} target="_blank" rel="noreferrer" data-testid="footer-instagram" className="hover:text-[var(--gold)] transition-colors"><Instagram size={18} /></a>}
              {social.linkedin && <a href={social.linkedin} target="_blank" rel="noreferrer" data-testid="footer-linkedin" className="hover:text-[var(--gold)] transition-colors"><Linkedin size={18} /></a>}
              {social.facebook && <a href={social.facebook} target="_blank" rel="noreferrer" data-testid="footer-facebook" className="hover:text-[var(--gold)] transition-colors"><Facebook size={18} /></a>}
            </div>
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.24em] text-[var(--gold)] mb-5">Service Areas</p>
            <div className="flex flex-wrap gap-x-4 gap-y-2">
              {(profile?.service_areas || []).map((a) => (
                <span key={a} className="text-[#FAF9F6]/80 text-sm">{a}</span>
              ))}
            </div>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-[#FAF9F6]/15 flex flex-col md:flex-row justify-between gap-4 text-xs text-[#FAF9F6]/50">
          <span>© {new Date().getFullYear()} {profile?.name}. All rights reserved.</span>
          <a href="/login" data-testid="footer-admin-link" className="hover:text-[#FAF9F6] transition-colors">Agent Login</a>
        </div>
      </div>
    </footer>
  );
}
